import { createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { AppShell } from '@/components/app-shell';

// Route context carries the QueryClient instance, enabling `beforeLoad`
// prefetching in child routes without re-reading from a global.
export interface RouterContext {
  queryClient: QueryClient;
}

// The routes are assembled in `src/router.ts` — this file only owns the
// root route definition. `AppShell` renders the tenant-scoped top nav
// and an <Outlet /> for child routes.
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: AppShell,
});
